var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C32.8788 20 27 25.6135 27 32.6667C27 39.7198 32.8788 45.3333 40 45.3333C47.1212 45.3333 53 39.7198 53 32.6667C53 25.6135 47.1212 20 40 20ZM29 52C25.5717 52 22.2719 53.32 19.8295 55.6884C17.3851 58.0588 16 61.2871 16 64.6667C16 65.3004 16.3003 65.8966 16.8095 66.2738L34 78.3221C34.8876 78.9795 36.9496 80.078 37.6071 79.1905C38.096 78.5305 38.1182 77.6688 37.7326 77H46C45.9998 77.4699 46.1643 77.9418 46.4993 78.3221C47.2294 79.1509 48.4932 79.2309 49.3221 78.5007L63.3221 66.1674C63.7531 65.7877 64 65.241 64 64.6667C64 61.2871 62.6149 58.0588 60.1705 55.6884C57.7281 53.32 54.4283 52 51 52H29Z",
    fill: "#B8BFF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    stroke: "#202B85",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.55842188aa0a1550fe7a823377621d0b.svg";
export { ForwardRef as ReactComponent };